<ion-header>
  <ion-toolbar color="primary" no-border-bottom>
    <ion-buttons slot="start">
      <ion-button (click)="_toggleGrid()">
        <!-- <ion-icon slot="icon-only" name="grid-outline" *ngIf="!showGrid"></ion-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-3x3 text-muted" viewBox="0 0 16 16" *ngIf="!showGrid">
          <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5zM1.5 1a.5.5 0 0 0-.5.5V5h4V1zM5 6H1v4h4zm1 4h4V6H6zm-1 1H1v3.5a.5.5 0 0 0 .5.5H5zm1 0v4h4v-4zm5 0v4h3.5a.5.5 0 0 0 .5-.5V11zm0-1h4V6h-4zm0-5h4V1.5a.5.5 0 0 0-.5-.5H11zm-1 0V1H6v4z"/>
        </svg>
        <!-- <ion-icon slot="icon-only" name="square-outline" *ngIf="showGrid"></ion-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-3x3" viewBox="0 0 16 16" *ngIf="showGrid">
          <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5zM1.5 1a.5.5 0 0 0-.5.5V5h4V1zM5 6H1v4h4zm1 4h4V6H6zm-1 1H1v3.5a.5.5 0 0 0 .5.5H5zm1 0v4h4v-4zm5 0v4h3.5a.5.5 0 0 0 .5-.5V11zm0-1h4V6h-4zm0-5h4V1.5a.5.5 0 0 0-.5-.5H11zm-1 0V1H6v4z"/>
        </svg>
      </ion-button>
    </ion-buttons>
    <!-- <ion-buttons slot="start">
      <ion-button (click)="_toggleGrid()">
        {{ 'APP.LABEL.Grid' | translate }}
      </ion-button>
    </ion-buttons> -->
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content padding>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="ratio- px-2 py-2 border" style="--bs-aspect-ratio: 125%;background-color: #fafafa;">
          <div id="my_camera" [class.camera-grid]="showGrid" style="width: 640px; height: 360px;">
            <div *ngIf="isCameraExist; else noCameraExist">
              <div class="camera-container" style="text-align:center">
                <webcam *ngIf="showWebcam"
                  [height]="height" [width]="width"
                  [allowCameraSwitch]="false"
                  [trigger]="triggerObservable"
                  [switchCamera]="nextWebcamObservable"
                  (cameraSwitched)="cameraWasSwitched($event)"
                  (imageCapture)="handleImage($event)"
                  (initError)="handleInitError($event)">
                </webcam>
                <div class="webcam-image" *ngIf="webcamImage" style="height: 360px;">
                  <img class="img-responsive-" style="width: 640px;" [src]="webcamImage.imageAsDataUrl" />
                </div>
              </div>
            </div>
            <ng-template #noCameraExist>
              Camera device not available
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col" *ngIf="false">
        <div class="mb-3">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label class="label-bold" for="device">{{ 'APP.LABEL.Device' | translate }}</label>
                <div class="">
                  <select class="form-select" [(ngModel)]="currentDevice" (change)="onChangeDevice($event)">
                    <option [value]="item.deviceId" *ngFor="let item of mediaDevices">
                      {{ item.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-danger" *ngIf="errors.length > 0">
          <h5>Error Messages:</h5>
          <ul class="" *ngFor="let error of errors">
            <li><span class="">{{ error.message }}</span></li>
          </ul>
        </div>
        <!-- <pre>{{ mediaDevices | json }}</pre> -->
        <!-- <ng-container *ngIf="errors.length === 0">
          <div class="btn-group">
            <button class="btn btn-primary" (click)="takeSnapshot($event)">{{ 'APP.BUTTON.TakePicture' | translate }}</button>
          </div>
          <div class="btn-group">
            <button class="btn btn-secondary" (click)="changeWebCam(true)">{{ 'APP.BUTTON.ToggleCamera' | translate }}</button>
          </div>
          <div class="btn-group">
            <button class="btn btn-secondary" (click)="onOffWebCam($event)">{{ 'APP.BUTTON.SwitchCamera' | translate }}</button>
          </div>
          <div class="btn-group ms-3" *ngIf="webcamImage">
            <button class="btn btn-secondary" (click)="onWebCam($event)">{{ 'APP.BUTTON.NewPicture' | translate }}</button>
          </div>
        </ng-container> -->
      </div>
    </div>
  </div>
</ion-content>

<ion-footer class="about-footer">
  <ion-toolbar color="ligth">
    <ion-buttons slot="start">
      <ion-button size="small" (click)="takeSnapshot($event)">{{ 'APP.BUTTON.TakePicture' | translate }}</ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button size="small" (click)="onWebCam($event)">{{ 'APP.BUTTON.NewPicture' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
